module.exports = __webpack_public_path__ + "img/制御工学3_7.4fd10cb7.png";